(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    customElements.define('slideshow-inline', class extends Core {
        defaultProps = {
            gap: window.gutterWidth,
            slidesPerView: 4
        }

        elements = {
            swiper: '[data-swiper]',
            pagination: '[data-pagination]',
            buttonPrev: '[data-button-prev]',
            buttonNext: '[data-button-next]'
        }

        render() {
            this._setSwiperProps();
            this._initSwiper();
            this._setSwiperPadding();
            this._setSwiperButtonsPosition();
        }
        
        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, this.swiperProps);
        }

        _setSwiperProps() {
            const breakpoints = this.withAdaptiveSlides ? this.adaptiveBreakpoints : {
                1: {
                    slidesPerView: 1.5,
                    spaceBetween: this.gap
                },
                992: {
                    slidesPerView: this.slidesPerView,
                    spaceBetween: this.gap
                }
            };
            this.swiperProps = {
                loop: this.withLoop,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints
            };
            if(this.withAdaptiveSlides) {
                this.swiperProps.breakpointsBase = 'container';
            }
            if(this.withOffset) {
                this.swiperProps.slidesOffsetBefore = this.offset;
                this.swiperProps.slidesOffsetAfter = this.offset;
            }
            if(this.$pagination) {
                this.swiperProps.pagination = {
                    el: this.$pagination,
                    type: 'bullets',
                    clickable: true
                }
                if(this.withOffset) {
                    this.$pagination.style.setProperty('--offset', `${this.offset}px`);
                } else {
                    this.swiperPadding && this.$pagination.style.setProperty('--offset', `${this.swiperPadding}px`);
                }
            }
        }
        
        _setSwiperButtonsPosition() {
            this.swiperPadding && this.$swiper.style.setProperty('--button-position', (this.swiperPadding - this.navButtonWidth / 2) + 'px');
        }

        _setSwiperPadding() {
            if (this.swiperPadding) {
                this.$swiper.style.paddingLeft = this.swiperPadding + 'px';
                this.$swiper.style.paddingRight = this.swiperPadding + 'px';
            }
            return;
        }

        get slidesPerView() {
            return this.getAttribute('slides-per-view') 
                && +this.getAttribute('slides-per-view') 
                || this.defaultProps.slidesPerView;
        }
        get slidesCount() {
            return this.getAttribute('slides-count');
        }
        get gap() {
            return this.getAttribute('gap') 
                && +this.getAttribute('gap') 
                || this.defaultProps.gap;
        }
        get withAdaptiveSlides() {
            return this.hasAttribute('adaptive-slides');
        }
        get adaptiveMinSlideWidth() {
            return this.getAttribute('adaptive-min-slide-width')
                && +this.getAttribute('adaptive-min-slide-width')
                || 200;
        }
        get adaptiveStartWidth() {
            return this.getAttribute('adaptive-start-width')
                && +this.getAttribute('adaptive-start-width')
                || 900;
        }
        get adaptiveBreakpoints() {
            const maxSlides = this.effectiveSlidesPerView;
            const firstDesktopSlides = Math.min(4, maxSlides);
            const breakpoints = {
                1: {
                    slidesPerView: Math.min(1.5, maxSlides),
                    spaceBetween: this.gap
                },
                [this.adaptiveStartWidth]: {
                    slidesPerView: firstDesktopSlides,
                    spaceBetween: this.gap
                }
            };
            for (let slides = firstDesktopSlides + 1; slides <= maxSlides; slides += 1) {
                breakpoints[Math.ceil((this.adaptiveMinSlideWidth * slides) + (this.gap * (slides - 1)))] = {
                    slidesPerView: slides,
                    spaceBetween: this.gap
                };
            }
            return breakpoints;
        }
        get effectiveSlidesPerView() {
            return Math.max(1, Math.min(this.slidesPerView, this.slidesCount || this.slidesPerView));
        }
        get withOffset() {
            return this.hasAttribute('offset');
        }
        get withLoop() {
            return this.hasAttribute('loop') && this.slidesCount > this.slidesPerView;
        }
        get slidesCount() {
            return Number(this.getAttribute('slides-count') || this.querySelectorAll('.swiper-slide').length);
        }
        get offset() {
            if (this.usesLocalContainer) return 0;
            return (document.documentElement.offsetWidth - window.containerInnerWidth) / 2;
        }

        get swiperPadding() {
            if (this.usesLocalContainer) return 0;
            return this.hasAttribute('container') && (document.documentElement.offsetWidth - window.containerInnerWidth) / 2;
        }

        get navButtonWidth() {
            return this.$buttonNext.offsetWidth;
        }

        get usesLocalContainer() {
            return this.closest('[data-pfu-recommend-contained-carousel]') !== null;
        }
    })
})();
